import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { InvoiceSelectionComponent } from '@components/invoice-selection/invoice-selection.component'
import { ApiService, UserInfo } from '../../../services/api.service'
import { NgIf } from '@angular/common'
import { InvoiceData } from '../../../interfaces/invoice-claim.interface'
import { TranslateModule } from '@ngx-translate/core'
import { ColumnConfig, ColumnFormat } from '@components/table/table.component'
import { ButtonComponent } from '@components/button/button.component'

@Component({
    selector: 'app-fabricator-select-invoices',
    templateUrl: './fabricator-select-invoices.component.html',
    styleUrl: './fabricator-select-invoices.component.scss',
    imports: [
        InvoiceSelectionComponent,
        NgIf,
        TranslateModule,
        ButtonComponent
    ],
    standalone: true
})
export class FabricatorSelectInvoicesComponent implements OnInit {
    @Input() saleId: string | null
    @Input() initialSelectedInvoices: InvoiceData[]
    selectedInvoices: InvoiceData[] = []

    @Output() onSelectedInvoices: EventEmitter<InvoiceData[]> = new EventEmitter()

    tableColumns: ColumnConfig[] = [
        { key: 'invoiceId', header: 'create-claim.material-selection.table.invoice' },
        { key: 'position', header: 'create-claim.material-selection.table.position' },
        { key: 'lotId', header: 'create-claim.material-selection.table.lote' },
        { key: 'createdDate', header: 'create-claim.material-selection.table.date', format: 'date' as ColumnFormat },
        { key: 'translatedDescription', header: 'global.description', format: 'translated_material' as ColumnFormat },
        { key: 'materialId', header: 'create-claim.material-selection.table.material' },
        {
            key: 'totalUnits',
            header: 'create-claim.material-selection.table.total_m2_sqft',
            format: 'number' as ColumnFormat,
            formatOptions: { decimals: '1.2-2' }
        },
        { key: 'measure', header: 'create-claim.material-selection.table.measure' },
        {
            key: 'cost',
            header: 'create-claim.material-selection.table.cost_net',
            format: 'currency' as ColumnFormat,
            formatOptions: { symbol: 'symbol', digits: '1.2-2' }
        }
    ]
    userInfo: UserInfo

    constructor(private api: ApiService) {
    }

    ngOnInit() {
        this.userInfo = this.api.userInfo.value
    }

    onInvoiceSelect($event: InvoiceData[]) {
        this.selectedInvoices = $event
    }

    canContinue() {
        return this.selectedInvoices.length > 0
    }

    onContinue() {
        if (this.canContinue()) {
            this.onSelectedInvoices.emit(this.selectedInvoices)
        }
    }
}
